import { MenuItem } from '@src/common/components/Menu';
import { useToast } from '@src/common/hooks/useToast';
import { ReopenOrderModal } from '@src/orders/components/orderActionsMenu/modal/ReopenOrderModal';
import type { OrderListing } from '@src/orders/domain/OrderList';
import { OrderActions } from '@src/orders/domain/OrderList';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  order: OrderListing;
  onStatusChange: () => void;
};
export const ReopenAction = ({ order, onStatusChange }: Props) => {
  const { t } = useTranslation();
  const { showSuccessToast, showErrorToast } = useToast();

  const [openReopenModal, setReopenModal] = useState(false);

  const openReopenOrderModal = () => {
    setReopenModal(true);
  };
  return (
    order.canDo(OrderActions.REOPEN) && (
      <>
        <MenuItem key={`${order.id}-reopen`} onClick={openReopenOrderModal}>
          {t('reopen')}
        </MenuItem>
        <ReopenOrderModal
          open={openReopenModal}
          onClose={() => {
            setReopenModal(false);
          }}
          onSuccess={() => {
            showSuccessToast(t('orderSummary.reopen.success'));
            onStatusChange();

            setReopenModal(false);
          }}
          onError={() => {
            showErrorToast(t('orderSummary.reopen.error'));
          }}
          order={order}
        />
      </>
    )
  );
};
